import CompanyRole from "./CompanyRole.js";

/**
 * `CompanyNonAdminRole` describes permissions of a company non
 * admin (e.g., import and normal) over other users.
 */
export default class CompanyNonAdminRole extends CompanyRole {
	canDeleteUser(user) {
		return user
			.getRoles()
			.every((role) => role.canBeDeletedByCompanyNonAdmin(this));
	}

	canAttachOrDetachCompanyId(user, company) {
		return user
			.getRoles()
			.some((role) =>
				role.canCompanyIdBeAttachedOrDetachedByCompanyNonAdmin(
					this,
					company,
				),
			);
	}

	canEditUserInfo(user) {
		return user
			.getRoles()
			.some((role) => role.canUserInfoBeEditedByCompanyNonAdmin(this));
	}

	canViewBudgetEditor(company) {
		return this.canViewAccountingDocuments(company);
	}
}
